import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import "./style.css";
import { useTranslation } from "react-i18next";
import { resolveFileUrl } from "constants/config";


export default function ScienceSelectTool(props) {
    const navigate = useNavigate();

    const { t, i18n } = useTranslation();
    let isRu = i18n.language == "ru";

    const PRODUCTS = [
        {
            id: "111",
            name: isRu ? "Наука в университетах" : "Science in Universities",
            description: "",
            partner: isRu ? "Объекты" : "Objects",
            url: "/science-labs",
            // image: img_c
            // image: "https://studtur.rudn.ru/files/dNCqcVG23q-6ef6029cc1d588764f66297fc4a9256a5e230eaced3ca44ce66de0699c28dfd7.jpg"
            // image: "https://студтуризм.рф/files/IBz5eLJdeu-97bf164374d2700ecfed155178d5ac4c0d2c498e36ad6605093131482d54cc9d.jpg"
            image: "https://студтуризм.рф/files/IBz5eLJdeu-2e9c724a22a7f7f0021633ac0325d1c7dd3e3258e592d708c457900fec3a3eb0.jpg"
        },
        {
            id: "111",
            name: isRu ? "Наука в движении" : "Science in Motion",
            description: "",
            partner: isRu ? "Маршруты" : "Routes",
            url: "/science-products",
            // image: "https://scienceid.net/upload/news/479/169167142964d4db85c7dce5.69716720.jpg"
            image: "https://студтуризм.рф/files/IBz5eLJdeu-fd55604a6ede5691bbf2b5df8c042c41e91a0a52213451da024c45ed8b39551b.jpg"
        }
    ];

    let arr = PRODUCTS;

    return (
        <Wrapper>

            {arr.map((a, i) => {
                return (
                    <div className="u-news-card-50 u-news-list__item u-news-card--default"
                         key={i}
                         onClick={() => {
                             navigate(a.url);
                         }}>
                        <div className="u-news-card__inner">
                            <div className="u-news-card__preview">

                                <img
                                    src={resolveFileUrl(a.image)}
                                    alt="Под полярным солнцем: как сити-фермы позволят выращивать растения в любой точке мира"
                                    className="u-news-card__image" />
                            </div>
                            <div className="u-news-card__main green_bg">
                                <time className="u-news-card__date u-news-card__date--over-image"> {a.partner}</time>
                                <div className="u-news-card__info">
                                    <h3>
                                        {a.name}
                                    </h3>
                                    <button
                                        className="custom-button u-news-card__learn-more custom-button--size-sm custom-button--theme-outline-light">

                                        <span className="custom-button__content more_button ">
                                            {
                                                isRu ? 'Узнать больше' : 'Learn more'
                                            }
                                        </span>

                                    </button>

                                </div>
                            </div>
                        </div>

                    </div>
                );
            })}

        </Wrapper>
    );
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -8px;
  justify-content: center;
`;

const Card = styled.div`
  width: 100%;
  max-width: 33.3333333333%;
  display: block;
  color: #fff;
  text-decoration: none;
  transition: all .3s ease;
  cursor: pointer;
  --bg-color: #003dff;
`;

const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  height: 100%;
  min-height: 400px;
  border-radius: 16px;
  overflow: hidden;
`;

const CardPreview = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;